module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_00.edd4aba6.gif";